import { getCompanyEvents } from "../services/apis/getCompanyEventDetails";
import { storeCompanyEvents, storeCorporateActions } from '../reducer/companyEvents.reducer'
import { AppDispatch } from "../store";

export const fetchCompanyEvents = async (dispatch: AppDispatch) => {
        try {
            const response = await getCompanyEvents();
            const companyEvents = Object.values(response.calendarEvents)
                .flatMap((eventList) => eventList.companyEvents);
            const corporateActions = Object.values(response.calendarEvents)
                .flatMap((eventList) => eventList.corporateActions);
            dispatch(storeCompanyEvents(companyEvents));
            dispatch(storeCorporateActions(corporateActions));

        } catch (error) {
            console.error("Error fetching company events:", error);
        }

};
